import { graphql } from '@/gql';
import type { AnnouncementsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';
import type { PaginatedAnnouncementTypeResponse } from '@/models/announcement';

export const fetchAnnouncements = async ({
  isActive,
  pagination,
}: AnnouncementsQueryVariables): Promise<PaginatedAnnouncementTypeResponse> => {
  const response = await queryExecute({
    query: graphql(`
      query Announcements($isActive: Boolean, $pagination: PaginationInputType) {
        announcements(isActive: $isActive, pagination: $pagination) {
          count
          rows {
            id
            title
            content
            expiredAt
            repeatedDate
            timeZone
            user {
              firstName
              lastName
            }
            createdAt
            updatedAt
          }
        }
      }
    `),
    variables: {
      isActive,
      pagination,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.announcements!;
};
